import { sendToApi } from 'api/client'
import { KanbanView, KanbanViewColumn } from 'types'

export const ProjectKanbanViewClient = {
  get: (projectId: string, kanbanViewId: number) =>
    sendToApi<{ kanban_view: KanbanView }>(`/projects/${projectId}/kanban_views/${kanbanViewId}`),

  update: (projectId: string, kanbanViewId: number, columns: KanbanViewColumn[]) =>
    sendToApi(`/projects/${projectId}/kanban_views/${kanbanViewId}`, {
      method: 'PUT',
      body: { columns },
    }),

  updateColumn: (projectId: string, kanbanViewId: number, column: KanbanViewColumn) =>
    sendToApi(`/projects/${projectId}/kanban_views/${kanbanViewId}/update_column`, {
      method: 'PUT',
      body: { column },
    }),
}
